"use client";

import type { ProtocolMetadata } from "@/types";

import React from "react";

import UiDetailsSingleStat from "@/components/Ui/Details/SingleStat";
import useProtocolStats from "@/hooks/api/useProtocolStats";
import { formatCurrencyCompact } from "@/utils";

interface ProtocolStatsProps {
  singleProtocol: ProtocolMetadata;
}

function getColor(value: number | string = 0) {
  const change = typeof value === "string" ? parseFloat(value) : value;

  if (change > 0) return "positive";
  if (change < 0) return "negative";
  return "neutral";
}

export default function ProtocolStats({ singleProtocol }: ProtocolStatsProps) {
  const { data: protocol, isLoading } = useProtocolStats(singleProtocol.id);

  return (
    (isLoading || protocol) && (
      <div className="flex flex-1 flex-col items-stretch justify-end gap-4 md:flex-row md:items-center md:justify-stretch xl:items-end">
        {protocol && (
          <>
            <UiDetailsSingleStat label="Protocol TVL" value={protocol.tvl} formatter={value => formatCurrencyCompact(value)} />
            <UiDetailsSingleStat
              label="Tvl 24HR Change"
              color={getColor(protocol.tvl_24h_change)}
              value={protocol.tvl_24h_change}
              formatter={value => `${parseFloat(`${value}`).toFixed(1)}%`}
            />
            <UiDetailsSingleStat label="Total # vaults" value={protocol.total_vaults} formatter={value => Intl.NumberFormat().format(value)} />
          </>
        )}
      </div>
    )
  );
}
